export default __webpack_public_path__ + "static/media/washdown.93906dab.png";